export enum ColumnConfigSource { EDIT, SAVE_AS, NO_CC };

export enum ColumnConfigDropdownSource { TABLE, EDITOR };

export const COLUMN_DEFAULT_WIDTH = 120;